/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import PropTypes from "prop-types";

import Label from '../formsUi/common/label/Label';
import TimePicker from "../formsUi/timePicker/TimePicker";
import ValidationMessage from '../formsUi/common/validation/ValidationMessage';

const FormTimePickerControls = ({
    dataField,
    labelName,
    name,
    value,
    error,
    formSetting,
    overRideProps,
    isRequired,
    fieldSetting,
    onChange,
    onBlur,
    onActionChange,
    inputInfoConfig
}) => {

    const handleInputChange = (value) => {
        if (onChange) {
            onChange(dataField, value);
        }
    };

    const handleOnBlur = () => {
        onBlur(dataField);
    };

    const handleButtonClick = (action, data) => {
        onActionChange(action);
    };

    return (
        <>
            <div className={`input-label-part ${fieldSetting?.mainDivClass || ""}`}>
                {labelName && labelName !== "" && (
                    <Label labelName={labelName} htmlFor={name} isRequired={isRequired} />
                )}
                {fieldSetting?.subTitle ? (
                    <div className={`"section-title" `}>
                        <h5>{fieldSetting.subTitle}</h5>
                    </div>
                ) : (
                    ""
                )}
                <div className={`input-top-title ${fieldSetting?.isFormControl ? "input-with-btn" : ""} `}>
                    <TimePicker
                        id={name}
                        name={name}
                        value={value}
                        onChange={handleInputChange}
                        onBlur={handleOnBlur}
                        iconConfig={fieldSetting?.iconConfig}
                        placeholder={fieldSetting?.placeholder}
                        isdisable={
                            formSetting?.isViewOnly ||
                            (overRideProps?.isDisable !== undefined
                                ? overRideProps?.isDisable
                                : fieldSetting?.isDisable) ||
                            false
                        }
                        isreadonly={
                            formSetting?.isReadOnly ||
                            (overRideProps?.isReadOnly !== undefined
                                ? overRideProps?.isReadOnly
                                : fieldSetting?.isReadOnly) ||
                            false
                        }
                        {...fieldSetting}
                    />
                    {fieldSetting?.isFormControl && fieldSetting?.formControltemplate(handleButtonClick)}
                </div>
            </div>
            <ValidationMessage error={error || ""}
                helperText={fieldSetting?.helperText}
                successText={overRideProps?.successText ?? fieldSetting?.successText} />
        </>
    );
};

FormTimePickerControls.propTypes = {
    dataField: PropTypes.string.isRequired,
    labelName: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.any,
    error: PropTypes.string,
    formSetting: PropTypes.object,
    formData: PropTypes.object,
    overRideProps: PropTypes.object,
    isRequired: PropTypes.bool,
    fieldSetting: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onValidation: PropTypes.func,
    onBlur: PropTypes.func,
    inputInfoConfig: PropTypes.object,
    onActionChange: PropTypes.func
};

export default React.memo(FormTimePickerControls);
